export default __webpack_public_path__ + "static/media/MDC.d0900109.svg";